import i18n from '@/lang/i18n'
import { CustomerGridRatesDatasource } from '@/modules/configurationModule/detail/local-accounting/billable/clients/datasource/configuration-local-accounting-billable-clients-grid-rates-datasource'
import { ConfigurationLocalAccountingBillableCustomerBillableRateResponse } from '@/modules/configurationModule/detail/local-accounting/billable/clients/services/customer-billable-rates-services/configuration-local-accounting-billable-clients-rates.dto'
import { configurationLocalAccountingBillableCustomerRatesService } from '@/modules/configurationModule/detail/local-accounting/billable/clients/services/customer-billable-rates-services/configuration-local-accounting-billable-clients-rates.service'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { initialCrudModelBaseState, CrudModelBase } from '@/shared/models/cruds.models'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { store } from '@/store/store'

export const localAccountingBillableCustomerRatesColumnsDef =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.rate'),
            field: 'rate.name',
            minWidth: 190,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.code'),
            field: 'rate.code',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.DATE,
            headerName: i18n.tc('configuration.grid.startDate'),
            field: 'rate.startDate',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.DATE,
            headerName: i18n.tc('configuration.grid.endDate'),
            field: 'rate.endDate',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.selfBilling'),
            field: 'isForAutoInvoice',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.modal.client.center'),
            field: 'casePhysicalCenterForAutoAssignment.name',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.regimes'),
            colId: 'caseRegimeForAutoAssignment.code',
            field: 'caseRegimeForAutoAssignment.name',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.modal.client.insurer'),
            field: 'caseInsurerForAutoAssignment.name',
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: `${i18n.tc('configuration.grid.priority')} (${i18n.tc('entities.coreEntities.case')})`,
            colId: 'casePriorityForAutoAssignment.code',
            field: 'casePriorityForAutoAssignment.name',
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: `${i18n.tc('configuration.grid.priority')} (${i18n.tc('configuration.sections.rate')})`,
            field: 'priorityForAutomaticAssignment',
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]

export interface ConfigurationLocalAccountingCustomerRateGridState<R = ConfigurationLocalAccountingBillableCustomerBillableRateResponse> extends CrudModelBase<R, CustomerGridRatesDatasource<R>> {
    service: typeof configurationLocalAccountingBillableCustomerRatesService
    laboratoryId: number
}
export const initialLocalAccountingCustomerRatesGridState =
    (customerId: number): ConfigurationLocalAccountingCustomerRateGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.accounting.clients.rates',
        columnsDef: localAccountingBillableCustomerRatesColumnsDef(),
        datasource: new CustomerGridRatesDatasource(configurationLocalAccountingBillableCustomerRatesService, store.getters.labId, customerId),
        service: configurationLocalAccountingBillableCustomerRatesService,
        laboratoryId: store.getters.labId
    })
